import React, { useState, useEffect, useCallback, useRef } from 'react';
import FilesItem from './FilesItem';
import styles from './FilesList.module.css';
import axios from 'axios';

const FilesList = ({ userId, restartAutoScroll, propBeats, isAuthenticated, setPurchasedFiles }) => {
  const [beats, setBeats] = useState([]);
  const [currentlyPlaying, setCurrentlyPlaying] = useState(null);
  const [selectedTags, setSelectedTags] = useState([]);
  const firstLoad = useRef(true);

  useEffect(() => {
    if (propBeats) {
      setBeats(propBeats);
      if (firstLoad.current && restartAutoScroll) {
      restartAutoScroll();
      firstLoad.current = false;
      }
    } else {
      const fetchBeats = async () => {
        try {
	  const token = localStorage.getItem('authToken');

          const response = await axios.get('/api/purchased/list', {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
          setBeats(response.data);

          if (firstLoad.current && restartAutoScroll) {
          restartAutoScroll();
	  firstLoad.current = false;
	 }
        } catch {
        }
      };

      fetchBeats();
    }
  }, [propBeats, restartAutoScroll]);

  const handlePlay = useCallback((playId) => {
    setCurrentlyPlaying(prev => (prev === playId ? null : playId));
  }, []);

  const handleTagClick = (tag) => {
    setSelectedTags((prevTags) => {
      if (prevTags.includes(tag)) {
        return prevTags.filter((t) => t !== tag);
      } else {
        return [...prevTags, tag];
      }
    });
  };

  const filteredBeats =
    selectedTags.length === 0
      ? beats
      : beats.filter(beat =>
          selectedTags.every(
            tag => beat.moodTags.includes(tag) || beat.artistSticker === tag
          )
        );

  return (
    <div className={styles.filesList}>
      {filteredBeats.map((beat) => {
       const playId = `${beat.id}-${beat.orderId}`;

       return (
        <FilesItem
          key={playId}
	  playId={playId}
          id={beat.id}
	  orderId={beat.orderId}
          title={beat.title}
          coverImage={beat.coverImage}
          genre={beat.genre}
          bpm={beat.bpm}
          keySignature={beat.keySignature}
          moodTags={beat.moodTags}
          purchasedWav={beat.purchasedWav}
          purchasedKit={beat.purchasedKit}
          licenseGenerated={beat.licenseGenerated}
          licenseUrl={beat.licenseUrl}
          downloadUrl={beat.downloadUrl}
          setPurchasedFiles={setPurchasedFiles}
          audioFile={beat.audioFile}
          isPlaying={currentlyPlaying === playId}
          onPlay={() => handlePlay(playId)}
          onTagClick={handleTagClick}
          selectedTags={selectedTags}
          isAuthenticated={isAuthenticated}
	  artistSticker={beat.artistSticker}
        />
       );
      })}
    </div>
  );
};

export default FilesList;

